import { logger } from '@zep/core-logger';
import { CountryCode } from '@zep/types';
import { SubscribePlan } from '../../../../../types/SubscriptionType';
import { getSubscriptionPlanLevel } from '../../subscriptionUtil';
export const useSubscriptionPaymentLog = (key: 'payment_subscription_next' | 'payment_subscription_purchase' | 'payment_subscription_purchase_complete', isShowRevenue: boolean, billingCycle: 'Monthly' | 'Annual') => {
  return (amplitudeData: SubscriptionPaymentLogPayload) => {
    const {
      spaceName,
      selectedCcu,
      selectedPlan,
      nowCcu,
      nowPlan,
      price,
      spaceHashId,
      currency,
      countryCode
    } = amplitudeData;
    const revenue = (() => {
      if (!isShowRevenue) return '';
      if (currency === 'USD') return price * 1200;
      return price;
    })();
    const upgrade_plan_type: LogType = (() => {
      if (!nowPlan) return 'first';
      if (nowPlan === selectedPlan) return 'same';

      // @ts-ignore
      const nowPlanLevel = getSubscriptionPlanLevel(nowPlan);

      // @ts-ignore
      const nextPlanLevel = getSubscriptionPlanLevel(selectedPlan);
      return nowPlanLevel > nextPlanLevel ? 'downgrade' : 'upgrade';
    })();
    const upgrade_ccu_type: LogType = (() => {
      if (!nowCcu) return 'first';
      if (nowCcu === selectedCcu) return 'same';
      return nowCcu > selectedCcu ? 'downgrade' : 'upgrade';
    })();
    return logger.track(key, {
      plan: selectedPlan,
      ccu: selectedCcu,
      prev_plan: nowPlan,
      prev_ccu: nowCcu,
      upgrade_plan_type,
      upgrade_ccu_type,
      currency,
      price,
      country_code: countryCode,
      space_id: spaceHashId,
      space_name: spaceName,
      ...(isShowRevenue && {
        $revenue: revenue
      }),
      ...(billingCycle && {
        billing_cycle: billingCycle
      })
    });
  };
};
type LogType = 'first' | 'upgrade' | 'downgrade' | 'same';
export type SubscriptionPaymentLogPayload = {
  nowCcu?: number;
  nowPlan?: string;
  selectedCcu: number;
  selectedPlan: Omit<SubscribePlan, 'free'>;
  currency: string;
  price: number;
  countryCode: CountryCode;
  spaceHashId: string;
  spaceName: string;
};